import React, { Component } from 'react';
import { Container, Row, Col, Button, Carousel, CarouselItem, CarouselIndicators } from 'reactstrap';

export class HeroSection extends Component {
  static displayName = HeroSection.name;

  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
      animating: false
    };
  }

  next = () => {
    if (this.state.animating) return;
    const nextIndex = this.state.activeIndex === this.carouselImages.length - 1 ? 0 : this.state.activeIndex + 1;
    this.setState({ activeIndex: nextIndex });
  }

  previous = () => {
    if (this.state.animating) return;
    const nextIndex = this.state.activeIndex === 0 ? this.carouselImages.length - 1 : this.state.activeIndex - 1;
    this.setState({ activeIndex: nextIndex });
  }

  goToIndex = (newIndex) => {
    if (this.state.animating) return;
    this.setState({ activeIndex: newIndex });
  }

  // Imágenes de ejemplo - Reemplazar con imágenes reales de la iglesia
  carouselImages = [
    {
      id: 1,
      src: "/images/carousel/iglesiaAll.jpg",
      alt: "Iglesia CBR - Culto Principal",
      title: "Iglesia CBR",
      subtitle: "Centro Bíblico Rodadero"
    },
    {
      id: 2,
      src: "/images/carousel/Parejas.png",
      alt: "Comunidad de Fe",
      title: "Comunidad de Fe",
      subtitle: "Creciendo juntos en Cristo"
    },
    {
      id: 3,
      src: "/images/carousel/cantando.jpg",
      alt: "Adoración y Alabanza",
      title: "Adoración y Alabanza",
      subtitle: "Alabando a nuestro Señor"
    },
    {
      id: 4,
      src: "/images/carousel/pastores.jpg",
      alt: "Pastores",
      title: "Pastores",
      subtitle: "Comunión y hermandad"
    }
  ];

  componentDidMount() {
    // Auto-advance carousel every 5 seconds
    this.interval = setInterval(() => {
      this.next();
    }, 5000);
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  render() {
    const { activeIndex } = this.state;

    const slides = this.carouselImages.map((image, index) => {
      return (
        <CarouselItem
          onExiting={() => this.setState({ animating: true })}
          onExited={() => this.setState({ animating: false })}
          key={image.id}
        >
          <div 
            className="hero-carousel-item"
            style={{
              height: '70vh',
              minHeight: '500px',
              backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url(${image.src})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center center',
              backgroundRepeat: 'no-repeat',
              backgroundAttachment: 'scroll',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <Container>
              <Row className="justify-content-center">
                <Col lg="10" className="text-center text-white">
                  <h1 className="hero-title fade-in-up" style={{ 
                    fontSize: '3.5rem', 
                    fontWeight: 'bold', 
                    marginBottom: '1rem',
                    textShadow: '2px 2px 4px rgba(0,0,0,0.7)'
                  }}>
                    {image.title}
                  </h1>
                  <h2 className="hero-subtitle fade-in-up" style={{ 
                    fontSize: '1.5rem', 
                    marginBottom: '2rem',
                    textShadow: '1px 1px 2px rgba(0,0,0,0.7)'
                  }}>
                    {image.subtitle}
                  </h2>
                  <p className="hero-quote fade-in-up" style={{ 
                    fontSize: '1.2rem', 
                    fontStyle: 'italic', 
                    color: 'var(--secondary-gold)', 
                    fontWeight: '600',
                    textShadow: '1px 1px 2px rgba(0,0,0,0.7)'
                  }}>
                    "Jesucristo es la oportunidad de tu vida"
                  </p>
                  <div className="mt-4">
                    <Button 
                      color="secondary" 
                      size="lg" 
                      className="me-3"
                      onClick={() => document.getElementById('about').scrollIntoView({ behavior: 'smooth' })}
                      style={{ borderRadius: '25px' }}
                    >
                      Conócenos
                    </Button>
                    <Button 
                      color="primary" 
                      size="lg"
                      onClick={() => document.getElementById('schedule').scrollIntoView({ behavior: 'smooth' })}
                      style={{ borderRadius: '25px' }}
                    >
                      Horarios
                    </Button>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </CarouselItem>
      );
    });

    return (
      <section className="hero-carousel-section">
        <Carousel
          activeIndex={activeIndex}
          next={this.next}
          previous={this.previous}
          interval={false} // Disable auto-advance since we handle it manually
        >
          {slides}
          <CarouselIndicators 
            items={this.carouselImages} 
            activeIndex={activeIndex} 
            onClickHandler={this.goToIndex} 
          />
        </Carousel>
      </section>
    );
  }
}
